module.exports = __webpack_public_path__ + "static/media/ic-apps-store.5e275329.webp";